export default __webpack_public_path__ + "static/media/VendingLogo.bca35049.png";